import React, { useState, useEffect, useContext } from 'react'
import { Navigate, Outlet, Link } from 'react-router-dom'
import { useAuth } from '../../hooks/auth'

import { ThemeContext } from '../../components/ThemeContext'

import logoBlack from '../../images/logo.png'
import logoWhite from '../../images/logo-w.png'

const AuthLayout: React.FC = () => {
    const { user } = useAuth()
    const [logo, setLogo] = useState(logoBlack)

    const { theme } = useContext(ThemeContext)

    useEffect(() => {
        if (localStorage.getItem('theme') === 'light') {
            setLogo(logoBlack)
        } else {
            setLogo(logoWhite)
        }
    }, [])

    if (user) {
        if (process.env.REACT_APP_MODE == 'site') {
            window.location.href = 'https://223.noxsys.ru'
        } else {
            return <Navigate to="/hub" />
        }
    }
    return (
        <div className="h-full flex flex-col">
            <header className="p-5">
                <Link
                    to="/"
                    className="flex flex-row justify-center items-center"
                    style={{ textDecoration: 'none' }}
                >
                    <img
                        width={40}
                        height={40}
                        src={theme == 'dark' ? logoWhite : logoBlack}
                        alt="Логотип"
                        className="me-2"
                    />
                    <span className="text-[#181818] dark:text-[#FFFFFF] uppercase leading-none font-semibold items-center justify-start text-left">
                        ТЕХНОЛОГИИ
                        <br />
                        ЗАКУПОК
                    </span>
                </Link>
            </header>
            <main className="flex grow justify-center items-center p-4">
                <div
                    className="w-full p-5 rounded-lg shadow-lg shadow-[#18181825] bg-[#e5e5e5] dark:bg-[#262427]"
                    style={{ maxWidth: '500px' }}
                >
                    <Outlet />
                </div>
            </main>
        </div>
    )
}

export default AuthLayout
